export const VIEW = {
    HOME: 'home',
    BABYLON: 'babylon',
    CESIUM: 'cesium',
    AUTH: 'auth',
}